import React, { useState, useRef, useEffect } from "react";
import {
  List,
  ListItemButton,
  ListItemText,
  Box,
  Divider,
  Paper,
  ThemeProvider,
  createTheme,
  Typography,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import HomeIcon from "@mui/icons-material/Home";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonIcon from '@mui/icons-material/Person';

import "./SideDrawer.css";
import ConditionalWrapper from "../common/Conditional/ConditionalWrapper";
// import {
//   componentsPath,
//   appRootUrl,
// } from "../../routes/PrivateRoutes";

const drawerWidth = 56;
const submenuWidth = 175;
const itemHeight = 40;
const seaGreen = "#000";

const topCategories = {

};

const staticIcons = {
  Home: <HomeIcon />,
  // Dashboard: <DashboardIcon />,
  // Supply: <LocalShippingIcon />,
  // Demand: <LocalMallIcon />,
  // Inventory: <Inventory2Icon />,
  "DQ S4": <SupervisorAccountIcon />,
  "DQ IBP": <HowToRegIcon />,
  // Planner: <PersonIcon />,
  // Analytics: <AssessmentIcon />,
};

const SideDrawer = ( { options, contentHeight } ) => {
  const listItems = options;
  const subOptions = options.map( opt => ( { id: opt.id, rules: opt.rules } ) )
  const [ selectedCategory, setSelectedCategory ] = useState( null );
  const [ selectedLabel, setSelectedLabel ] = useState( null );

  const [ showSubmenu, setShowSubmenu ] = useState( false );
  const [ submenuTop, setSubmenuTop ] = useState( contentHeight || 100 );
  const arrowRefs = useRef( {} );
  const drawerRef = useRef( null );
  const submenuRef = useRef( null );
  const navigate = useNavigate();
  const location = useLocation();

  const theme = createTheme( {
    typography: {
      fontSize: 11,
    },
  } );

  // const labelToPathMap = Object.fromEntries(
  //   componentsPath.map( ( { label, path } ) => [ label, path ] )
  // );

  // useEffect( () => {
  //   const currentPath = location.pathname;
  //   const matchedEntry = Object.entries( labelToPathMap ).find( ( [ label, path ] ) =>
  //     currentPath.startsWith( path )
  //   );

  //   const matchedLabel = matchedEntry?.[ 0 ];
  //   setSelectedLabel( matchedLabel || null );

  // }, [ location.pathname ] );

  const handleRedirect = ( label, menu ) => {
    // const path = labelToPathMap[ label ];
    if ( label === "Home" ) {
      window.location.href = '/';
      navigate( '/' )
      return;
    }
    // navigate( path || "/blank", {
    //   state: { menu, label },
    // } );
    // setShowSubmenu( false );
  };

  useEffect( () => {
    const handleClickOutside = ( event ) => {
      if (
        submenuRef.current &&
        !submenuRef.current.contains( event.target ) &&
        drawerRef.current &&
        !drawerRef.current.contains( event.target )
      ) {
        setShowSubmenu( false );
      }
    };

    document.addEventListener( "mousedown", handleClickOutside );
    return () => {
      document.removeEventListener( "mousedown", handleClickOutside );
    };
  }, [] );

  const handleCategoryClick = ( e, item ) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const offsetTop = rect?.top || 0;
    const drawerTop = contentHeight || 0;
    const estimatedHeight = 0;
    const availableSpaceBelow = window.innerHeight - offsetTop;
    const availableSpaceAbove = offsetTop - drawerTop;

    let adjustedTop = offsetTop - drawerTop;

    if (
      estimatedHeight > availableSpaceBelow &&
      availableSpaceAbove > availableSpaceBelow
    ) {
      adjustedTop = Math.max(
        0,
        offsetTop - drawerTop - estimatedHeight + itemHeight
      );
    } else if ( adjustedTop + estimatedHeight > window.innerHeight - drawerTop ) {
      adjustedTop = Math.max(
        0,
        window.innerHeight - drawerTop - estimatedHeight
      );
    }
    setSelectedCategory( item.id )
    setShowSubmenu( true )
    setSubmenuTop( adjustedTop );
  };

  console.log( 'env.....', process.env.REACT_APP_ENVT )

  const RenderNavItem = ( {
    label,
    icon,
    isActive,
    onClick,
    ref = null
  } ) => {
    const [ active, setActive ] = useState( false )
    const handleClick = ( e ) => {
      setActive( active => !active )
      onClick( e )
    }
    return (
      <ListItemButton
        id={ label }
        ref={ ref }
        onClick={ handleClick }
        sx={ {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          backgroundColor: active ? "#000" : "transparent",
          transition: "background-color 0.2s",
          opacity: 1,
          cursor: "pointer",
          "&:hover": {
            backgroundColor: active ? '#fff' : '#000',
            "& .nav-icon, & .nav-label": {
              color: active ? "#000" : '#fff',
            },
          },
        }
        }
      >
        <Box
          className="nav-icon"
          sx={ {
            color: isActive ? "#fff" : "#000",
            mb: 0.3,
            "& svg": { fontSize: "1.1rem" },
          } }
        >
          { icon }
        </Box>
        < Typography
          className="nav-label"
          variant="caption"
          sx={ {
            fontSize: "0.50rem",
            color: isActive ? "#fff" : "#000",
            textAlign: "center",
            lineHeight: 1.1,
          } }
        >
          { label }
        </Typography>
      </ListItemButton>
    )
  }

  return (
    <ThemeProvider theme={ theme } >
      <Box
        id='side-drawer'
        ref={ drawerRef }
        sx={ {
          width: drawerWidth,
          backgroundColor: "#ddd",
          color: "#fff",
          // position: "fixed",
          top: contentHeight || 0,
          bottom: 20,
          left: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          pt: 0,
          pb: 0,
        } }
      >
        {
          [ "Home" ].map( ( label ) =>
            <RenderNavItem
              label={ label }
              icon={ <HomeIcon /> }
              isActive={ selectedLabel === label }
              onClick={ () => handleRedirect( label, label ) }
            />
          )
        }
        < Divider sx={ { width: "100%", borderColor: "#888", mt: 0 } } />

        {
          listItems.map( ( item, idx ) =>
            <>
              <RenderNavItem
                label={ item.name }
                icon={ item.icon }
                isActive={ selectedLabel === item.name }
                onClick={ ( e ) => handleCategoryClick( e, item ) }
                ref={ arrowRefs }
              />
              <ConditionalWrapper key={ item } condition={ idx !== listItems.length - 1 }>
                < Divider sx={ { width: "100%", borderColor: "#888", mt: 0 } } />
              </ConditionalWrapper>
            </>
          )
        }

      </Box>

      {
        showSubmenu && (
          <Paper
            elevation={ 4 }
            ref={ submenuRef }
            sx={ {
              position: "fixed",
              top: submenuTop + ( contentHeight || 0 ),
              left: drawerWidth,
              width: submenuWidth,
              borderRadius: 4,
              height: '300px',
              overflow: 'hidden'
            }
            }
          >
            <List disablePadding className="submenu-panel">
              {
                subOptions
                  .filter( opt => opt.id === selectedCategory )
                  .map( opt => opt.rules )[ 0 ]
                  .map( ( opt ) => {
                    const isEnabled = true

                    return (
                      <ListItemButton
                        key={ opt.name }
                        className="submenu-item"
                        disabled={ !isEnabled }
                        onClick={ () =>
                          isEnabled && handleRedirect( opt, selectedCategory )
                        }
                        sx={ {
                          opacity: isEnabled ? 1 : 0.5,
                          cursor: isEnabled ? "pointer" : "not-allowed",
                          borderRadius: 4,
                          '&:hover': {
                            backgroundColor: isEnabled ? '#000' : '',
                            color: isEnabled ? '#fff' : ''
                          }
                        } }
                      >
                        <ListItemText primary={ opt.name } />
                      </ListItemButton>
                    );
                  } ) }
            </List>
          </Paper>
        ) }
    </ThemeProvider>
  );
};

export default SideDrawer;
